export const trackingConst = {
  events: {
    buttonClicked: "Button Clicked",
    upgradeLinkClick: "UpgradeLinkClick",
    linkClicked: "Link Clicked",
    notificationsClicked: "Notifications Clicked",
    notificationsItemClicked: "Notifications Item Clicked",
    notificationsItemUrlClicked: "Notifications Item Url Clicked",
    navigationClicked: "Navigation Clicked",
    businessUnitSelected: "Business Unit Selected",
    accountSelected: "Account Selected",
    experimentViewed: "ExperimentViewed",
    elementViewed: "Element Viewed",
    helpWanted: "Help Wanted",
  },
  contexts: {
    businessUnitSelector: "Business Unit Selector",
    accountSelector: "Account Selector",
    accountSelectorModal: "Account Selector Modal",
    sidebar: "Sidebar",
    appshell: "Appshell",
    freeTrialModal: "Free Trial Modal",
  },
  types: {
    contentIntegrity: "Content Integrity",
  },
  names: {
    accountSelectorOpened: "Account selector opened",
    goToPublicProfileConsumerSite: "go-to-public-profile-consumer-site",
    notificationClicked: "notification-clicked",
    notificationItemClicked: "notification-item-clicked",
    settingsMenu: "Settings Menu",
    navigationToggled: "Navigation Toggled",
    menuLeftSidebar: "MenuLeftSidebar",
    freeTrialUpradeLinkClick: "upgrade",
    freeTrialCheckoutLinkClick: "checkout",
    freeTrialClosed: "closed",
    freeTrialOpened: "open",
    cancelFreeTrial: "Cancel Free Trial Clicked",
    contentIntegrity: {
      BiasedInvitation: "BiasedInvitation",
      BiasedReportingForPersonalInformation: "BiasedReportingForPersonalInformation",
      CeaseAndDesistFabricatedReviews: "CeaseAndDesistFabricatedReviews",
      CherryPicking: "CherryPicking",
      EducationalFabricatedReviews: "EducationalFabricatedReviews",
      FabricatedReviews: "FabricatedReviews",
      FabricationByBusinessUser1: "FabricationByBusinessUser1",
      FabricationByBusinessUser2: "FabricationByBusinessUser2",
      IncentiveToChange: "IncentiveToChange",
      IncentiveToWritePositiveReviews: "IncentiveToWritePositiveReviews",
      MisuseOfPublicReplyFunction: "MisuseOfPublicReplyFunction",
      MisuseOfReportingFunction: "MisuseOfReportingFunction",
      ThreatToChangeOrDeleteNegativeReviews: "ThreatToChangeOrDeleteNegativeReviews",
      EducationalMisuseOfReporting: "EducationalMisuseOfReporting",
      WarningMisuseOfReporting: "WarningMisuseOfReporting",
      CeaseAndDesistMisuseOfReporting: "CeaseAndDesistMisuseOfReporting",
      FurtherActionMisuseOfReporting: "FurtherActionMisuseOfReporting",
      EducationalProfileViolation: "EducationalProfileViolation",
      ProfileViolation: "WarningProfileViolation",
      CeaseAndDesistProfileViolation: "CeaseAndDesistProfileViolation",
      WarningLegalThreatsTowardReviewer: "WarningLegalThreatsTowardReviewer",
      FurtherActionScammerBusiness: "FurtherActionScammerBusiness",
      EducationalBrandMisuse: "EducationalBrandMisuse",
      WarningBrandMisuse: "WarningBrandMisuse",
      CeaseAndDesistBrandMisuse: "CeaseAndDesistBrandMisuse",
      FurtherActionBrandMisuse: "FurtherActionBrandMisuse",
      EducationalFabrication: "EducationalFabrication",
      WarningFabrication: "WarningFabrication",
      CeaseAndDesistFabrication: "CeaseAndDesistFabrication",
      FurtherActionFabricatedReviews: "FurtherActionFabricatedReviews",
      EducationalIncentivesInInvitations: "EducationalIncentivesInInvitations",
      WarningIncentivesInInvitations: "WarningIncentivesInInvitations",
      CeaseAndDesistIncentivesInInvitations: "CeaseAndDesistIncentivesInInvitations",
      FurtherActionIncentivesInInvitations: "FurtherActionIncentivesInInvitations",
    },
  },
};

export const auSupportPhoneNumber = "+61 18-0014-7508";
export const SIMPLICITY_DATA_SENT = "tp-b2b-simplicity-data-sent";
export const defaultLocale = "en-US";

export const notificationModals = {
  YOUR_ROLE: "your-role",
};

export const SentryDSN = "https://55f1189c09354d9081bbc669ddef3cce@o211375.ingest.sentry.io/6457293";

export const claimPageUrl = "/onboarding/claim";

export const APPSHELL_PREFERENCES = "appshellpreferences";
export const NEW_NAVIGATION_SEEN = "new-navigation-seen";

export const TEST_USER_EMAILS = ["@tp-automatedtesting.com", "@automated.tp-testing.com"];

export const ALL_BUSINESS_ACCOUNTS_HAVE_SSO_ENFORCED = "All business accounts have SSO enforced, SSO login required";
